import React, { useMemo } from 'react';
import Context from '../../internal-components/GeneralContext';
import EmptyPageStateView from '../view/EmptyPageStateView';

const EmptyPageStateEngine = ({
  title,
  description,
  imageSrc,
  button,
  linkText,
  to,
  onLinkClicked,
  actionPrivileges,
  wrapperCSS = ''
}) => {
  const api = useMemo(() => ({
    title,
    imageSrc,
    description,
    button,
    linkText,
    to,
    onLinkClicked,
    actionPrivileges
  }));

  const viewProps = {
    wrapperCSS
  };

  return (
    <Context.Provider value={api}>
      <EmptyPageStateView {...viewProps} />
    </Context.Provider>
  );
};

export default EmptyPageStateEngine;
